export default __webpack_public_path__ + "static/media/gotham-bold.73ce573b.woff2";